import { Injectable } from "@angular/core";

import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { AppConfigService } from "./app-config.service";
import { StorageService } from "./storage.service";


@Injectable({
  providedIn: "root",
})
export class APIService {

  constructor(private http: HttpClient
  ) {

  }

  public get(apiUrl: string, options: any = null): Observable<any> {
    if (options != null) {
      return this.http.get(this.getFullURL(apiUrl), options);
    } else {
      return this.http.get(this.getFullURL(apiUrl));
    }
  }

  public post(apiUrl: string, data: any, options: any = null): Observable<any> {
    let headers = new HttpHeaders();

    // If data is FormData, remove 'Content-Type' (let browser set it)
    if (!(data instanceof FormData)) {
      headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    }

    const requestOptions = options ? { headers, ...options } : { headers };
    return this.http.post(this.getFullURL(apiUrl), data, requestOptions);
  }
  public put(apiUrl: string, data: any, options: any = null): Observable<any> {
    let headers = new HttpHeaders();

    // If data is FormData, remove 'Content-Type' (let browser set it)
    if (!(data instanceof FormData)) {
      headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    }

    const requestOptions = options ? { headers, ...options } : { headers };
    return this.http.put(this.getFullURL(apiUrl), data, requestOptions);
  }
  // public patch(apiUrl: string, data: any, options: any = null): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json; charset=utf-8'
  //   });
  //   const requestOptions = options ? { headers, ...options } : { headers };
  //   return this.http.patch(this.getFullURL(apiUrl), data, requestOptions);
  // }

  // public delete(apiUrl: string, options: any = null): Observable<any> {
  //   const requestOptions = options ? { ...options } : {};
  //   if (options != null) {
  //     return this.http.delete(this.getFullURL(apiUrl), requestOptions);
  //   } else {
  //     return this.http.delete(this.getFullURL(apiUrl));
  //   }
  // }

  // public put(apiUrl: string, data: any, options: any = null): Observable<any> {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json; charset=utf-8'
  //   });
  //   const requestOptions = options ? { headers, ...options } : { headers };
  //   const url = this.baseUrl.endsWith('/') ? this.baseUrl : this.baseUrl + '/';
  //   return this.http.put(url + apiUrl, data, requestOptions);
  // }


  public delete(apiUrl: string, options: any = null): Observable<any> {
    const requestOptions = options ? { ...options } : {};
    if (options != null) {
      return this.http.delete(this.getFullURL(apiUrl), requestOptions);
    } else {
      return this.http.delete(this.getFullURL(apiUrl));
    }
  }

  private getFullURL(url: string, actionType: string = "") {
    if (url.startsWith("/")) {
      url = url.substring(1);
    }
    let _baseurl = AppConfigService.settings?.urls?.apiBaseURL;
    if (!!_baseurl)
      _baseurl = _baseurl.endsWith('/') ? _baseurl : _baseurl + '/';
    return _baseurl + url;
  }


}
